module.exports = __webpack_public_path__ + "img/product2.91c03408.png";